import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  cardContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    gap: 16,
    marginBottom: 8,
  },
  filterField: {
    minWidth: 150,
  },
  filterActions: {
    display: 'flex',
    alignItems: 'flex-end',
    marginLeft: 'auto',
  },
  resetButton: {
    textTransform: 'none',
    border: 'none',
  },
  tableWrapper: {
    flex: 1,
    overflow: 'auto',
    minHeight: 0,
  },
  headCell: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  cell: {
    fontSize: 13,
  },
  cellNoWrap: {
    fontSize: 13,
    whiteSpace: 'nowrap',
  },
  action: {
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    fontSize: 12,
  },
  resourceId: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    overflowWrap: 'anywhere',
    maxWidth: 260,
    display: 'inline-block',
  },
  status: {
    color: theme.palette.text.secondary,
    display: 'block',
    padding: 24,
    textAlign: 'center',
  },
  statusError: {
    color: theme.palette.error.main,
    display: 'block',
    padding: 24,
    textAlign: 'center',
  },
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    padding: 24,
  },
}));

export default styles;
